import * as Yup from "yup";
import { waterCodes } from "../../../../utils/dataAndFormulas/waterForms";

export function initialValues(form, period, year, unitsRecorded) {
  return {
    date: form?.date || "",
    creator_user: form?.creator_user || "",
    period: form?.period || period,
    year: form?.year || year,
    state: form?.state || "",
    water_domestic_municipal_network:
      form?.water_domestic_municipal_network || {
        code: waterCodes["water_domestic_municipal_network"],
        unit: unitsRecorded?.["water_domestic_municipal_network"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    municipal_network_water_production:
      form?.municipal_network_water_production || {
        code: waterCodes["municipal_network_water_production"],
        unit: unitsRecorded?.["municipal_network_water_production"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    combined_municipal_network_water:
      form?.combined_municipal_network_water || {
        code: waterCodes["combined_municipal_network_water"],
        unit: unitsRecorded?.["combined_municipal_network_water"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    water_cost_domestic_municipal_network:
      form?.water_cost_domestic_municipal_network || {
        code: waterCodes["water_cost_domestic_municipal_network"],
        unit: unitsRecorded?.["water_cost_domestic_municipal_network"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    water_cost_municipal_network_production:
      form?.water_cost_municipal_network_production || {
        code: waterCodes["water_cost_municipal_network_production"],
        unit: unitsRecorded?.["water_cost_municipal_network_production"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    water_cost_combined_municipal_network:
      form?.water_cost_combined_municipal_network || {
        code: waterCodes["water_cost_combined_municipal_network"],
        unit: unitsRecorded?.["water_cost_combined_municipal_network"] || "",
        value: 0,
        reviews: [],
        approvalStatus: "pending",
        files: [],
      },
    domestic_groundwater: form?.domestic_groundwater || {
      code: waterCodes["domestic_groundwater"],
      unit: unitsRecorded?.["domestic_groundwater"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    groundwater_production: form?.groundwater_production || {
      code: waterCodes["groundwater_production"],
      unit: unitsRecorded?.["groundwater_production"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    groundwater_combined: form?.groundwater_combined || {
      code: waterCodes["groundwater_combined"],
      unit: unitsRecorded?.["groundwater_combined"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    domestic_groundwater_cost: form?.domestic_groundwater_cost || {
      code: waterCodes["domestic_groundwater_cost"],
      unit: unitsRecorded?.["domestic_groundwater_cost"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    groundwater_production_cost: form?.groundwater_production_cost || {
      code: waterCodes["groundwater_production_cost"],
      unit: unitsRecorded?.["groundwater_production_cost"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    groundwater_combined_cost: form?.groundwater_combined_cost || {
      code: waterCodes["groundwater_combined_cost"],
      unit: unitsRecorded?.["groundwater_combined_cost"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    rainwater: form?.rainwater || {
      code: waterCodes["rainwater"],
      unit: unitsRecorded?.["rainwater"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    surface_water: form?.surface_water || {
      code: waterCodes["surface_water"],
      unit: unitsRecorded?.["surface_water"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    distilled_water: form?.distilled_water || {
      code: waterCodes["distilled_water"],
      unit: unitsRecorded?.["distilled_water"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    reused_water: form?.reused_water || {
      code: waterCodes["reused_water"],
      unit: unitsRecorded?.["reused_water"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    recycled_water: form?.recycled_water || {
      code: waterCodes["recycled_water"],
      unit: unitsRecorded?.["recycled_water"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
    steam_condensed_water: form?.steam_condensed_water || {
      code: waterCodes["steam_condensed_water"],
      unit: unitsRecorded?.["steam_condensed_water"] || "",
      value: 0,
      reviews: [],
      approvalStatus: "pending",
      files: [],
    },
  };
}

export function validationSchema() {
  return Yup.object({
    period: Yup.string("Dato requerido").required(
      "El campo periodo es obligatorio"
    ),
water_domestic_municipal_network: Yup.object({
    value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
    unit: Yup.string().when("value", {
      is: (val) => val !== 0 && val !== null && val !== "",
      then: (schema) => schema.required("Debe completar la unidad"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),

  municipal_network_water_production: Yup.object({
    value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
    unit: Yup.string().when("value", {
      is: (val) => val !== 0 && val !== null && val !== "",
      then: (schema) => schema.required("Debe completar la unidad"),
      otherwise: (schema) => schema.notRequired(),
    }),
  }),

combined_municipal_network_water: Yup.object({
  value: Yup.number()
    .min(0, "Debe ser mayor o igual a 0")
    .test(
      "no-if-others-filled",
      " Agua combinada municipal no se debe completar si ya ingreso información en el campo agua domestica o de Producción",
      function (value) {
        // accedemos a los otros campos hermanos
        const root = this.options.context || this.from?.[1]?.value || this.parent?.parent;
        const domestic = root?.water_domestic_municipal_network?.value;
        const production = root?.municipal_network_water_production?.value;

         const domesticFilled = domestic !== null && domestic !== undefined && domestic !== "" && domestic !== 0;
        const productionFilled = production !== null && production !== undefined && production !== "" && production !== 0;
        const combinedFilled = value !== null && value !== undefined && value !== "" && value !== 0;

        if ((domesticFilled || productionFilled) && combinedFilled) {
          return this.createError({
            path: `${this.path}`,
            message:
              "Agua combinada municipal no se debe completar si ya ingresó información en el campo Agua doméstica o de Producción",
          });
        }

        return true;
      }
    ),
  unit: Yup.string().when("value", {
    is: (val) => val !== 0 && val !== null && val !== "",
    then: (schema) => schema.required("Debe completar la unidad"),
    otherwise: (schema) => schema.notRequired(),
  }),
}),

    water_cost_domestic_municipal_network: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    water_cost_municipal_network_production: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    water_cost_combined_municipal_network: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0")
      .test(
      "no-if-others-filled",
      " Agua combinada municipal no se debe completar si ya ingreso información en el campo agua domestica o de Producción",
      function (value) {
        // accedemos a los otros campos hermanos
        const root = this.options.context || this.from?.[1]?.value || this.parent?.parent;
        const domestic = root?.water_cost_domestic_municipal_network?.value;
        const production = root?.water_cost_municipal_network_production?.value;

          const domesticFilled = domestic !== null && domestic !== undefined && domestic !== "" && domestic !== 0;
        const productionFilled = production !== null && production !== undefined && production !== "" && production !== 0;
        const combinedFilled = value !== null && value !== undefined && value !== "" && value !== 0;;

        if ((domesticFilled || productionFilled) && combinedFilled) {
          return this.createError({
            path: `${this.path}`,
            message:
              "Agua combinada municipal no se debe completar si ya ingresó información en el campo Agua doméstica o de Producción",
          });
        }

        return true;
      }
    ),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    domestic_groundwater: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    groundwater_production: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    groundwater_combined: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0")
      .test(
      "no-if-others-filled",
      " Agua combinada municipal no se debe completar si ya ingreso información en el campo agua domestica o de Producción",
      function (value) {
        // accedemos a los otros campos hermanos
        const root = this.options.context || this.from?.[1]?.value || this.parent?.parent;
        const domestic = root?.domestic_groundwater?.value;
        const production = root?.groundwater_production?.value;

          const domesticFilled = domestic !== null && domestic !== undefined && domestic !== "" && domestic !== 0;
        const productionFilled = production !== null && production !== undefined && production !== "" && production !== 0;
        const combinedFilled = value !== null && value !== undefined && value !== "" && value !== 0;;

        if ((domesticFilled || productionFilled) && combinedFilled) {
          return this.createError({
            path: `${this.path}`,
            message:
              "Agua combinada municipal no se debe completar si ya ingresó información en el campo Agua doméstica o de Producción",
          });
        }

        return true;
      }
    ),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    domestic_groundwater_cost: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    groundwater_production_cost: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    groundwater_combined_cost: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0")    
      .test(
      "no-if-others-filled",
      " Agua combinada municipal no se debe completar si ya ingreso información en el campo agua domestica o de Producción",
      function (value) {
        // accedemos a los otros campos hermanos
        const root = this.options.context || this.from?.[1]?.value || this.parent?.parent;
        const domestic = root?.domestic_groundwater_cost?.value;
        const production = root?.groundwater_production_cost?.value;

           const domesticFilled = domestic !== null && domestic !== undefined && domestic !== "" && domestic !== 0;
        const productionFilled = production !== null && production !== undefined && production !== "" && production !== 0;
        const combinedFilled = value !== null && value !== undefined && value !== "" && value !== 0;

        if ((domesticFilled || productionFilled) && combinedFilled) {
          return this.createError({
            path: `${this.path}`,
            message:
              "Agua combinada municipal no se debe completar si ya ingresó información en el campo Agua doméstica o de Producción",
          });
        }

        return true;
      }
    ),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    rainwater: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    surface_water: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    distilled_water: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    reused_water: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    recycled_water: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
    steam_condensed_water: Yup.object({
      value: Yup.number().min(0, "Debe ser mayor o igual a 0"),
      unit: Yup.string().when("value", {
        is: (val) => val !== 0 && val !== null && val !== "",
        then: (schema) => schema.required("Debe completar la unidad"),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
  });
}
